// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type PreviewIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from preview.svg
 */
export default function PreviewIcon(props: PreviewIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="PreviewIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2m-.492 2.138A1 1 0 0 0 6 5v6l.006.11a1 1 0 0 0 1.594.69l4-3 .1-.085a1 1 0 0 0-.1-1.515l-4-3z"
        />
      </g>
    </svg>
  );
}
